import { defineMessages } from 'react-intl';

var MESSAGES = defineMessages({
  uploadFile: {
    id: "neptune.UploadButton.uploadFile"
  },
  uploadFiles: {
    id: "neptune.UploadButton.uploadFiles"
  },
  instructions: {
    id: "neptune.UploadButton.instructions"
  },
  maximumFiles: {
    id: "neptune.UploadButton.maximumFiles"
  },
  allFileTypes: {
    id: "neptune.UploadButton.allFileTypes"
  },
  dropFile: {
    id: "neptune.UploadButton.dropFiles"
  }
});

export { MESSAGES as default };
//# sourceMappingURL=UploadButton.messages.mjs.map
